import { Component, OnInit } from '@angular/core';
import { TerrainHeightService } from '../services/terrain-height.service';
import * as olProj from 'ol/proj'; import olMap from 'ol/Map';
import { Stroke, Style } from 'ol/style';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import { MapService } from 'src/app/services/map.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { SearchService } from 'src/app/services/search.service';
import { SearchItem } from 'src/app/models/searchItem';

@Component({
  selector: 'app-terrain-height',
  templateUrl: './terrain-height.component.html',
  styleUrls: ['./terrain-height.component.scss'],
  standalone: false
})
export class TerrainHeightComponent implements OnInit {

  constructor(public terrainHeightService: TerrainHeightService) {

  }

  ngOnInit(): void {
  }

}
